import React from 'react';
import { GOLD, BLACK } from '../constants/theme';

const data = [['500+','Events Catered'],['50+','Cuisine Varieties'],['10+','Years Experience'],['10K+','Happy Guests']];

const Stats: React.FC = () => (
  <div style={{ background:`linear-gradient(135deg,${GOLD} 0%,#8a6a1a 50%,${GOLD} 100%)`, padding:'26px 8vw', display:'flex', justifyContent:'space-around', flexWrap:'wrap', gap:16 }}>
    {data.map(([n,l]) => (
      <div key={l} style={{ textAlign:'center' }}>
        <div style={{ fontFamily:'Cormorant Garamond', fontSize:38, fontWeight:600, color:BLACK, lineHeight:1 }}>{n}</div>
        <div style={{ fontFamily:'Montserrat', fontSize:9, letterSpacing:3, color:'rgba(0,0,0,0.62)', textTransform:'uppercase', marginTop:3 }}>{l}</div>
      </div>
    ))}
  </div>
);

export default Stats;